import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { ShieldCheck, ShieldAlert } from "lucide-react";

const itDate = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00`).toLocaleDateString("it-IT") : null);

export default function PortaleAssicurazione() {
  const { data } = useQuery({ queryKey: ["my-insurance"], queryFn: async () => (await api.get("/insurance/me")).data });
  if (!data) return <div className="p-10 text-sm text-stone-400">Caricamento…</div>;
  const ok = data.insured;
  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[800px] mx-auto space-y-5" data-testid="portal-insurance-page">
      <PageHeader title="Assicurazione" subtitle="L'assicurazione è annuale e scade il 31 dicembre di ogni anno."/>
      <Card className={`p-6 rounded-xl shadow-none border flex items-center gap-4 ${ok ? "border-emerald-200 bg-emerald-50/60" : "border-red-200 bg-red-50/60"}`} data-testid="insurance-status">
        <div className={`w-14 h-14 rounded-full grid place-items-center shrink-0 ${ok ? "bg-emerald-600" : "bg-red-600"} text-white`}>{ok ? <ShieldCheck size={26}/> : <ShieldAlert size={26}/>}</div>
        <div>
          <div className="text-[11px] uppercase tracking-widest text-stone-500">Anno {data.year}</div>
          <div className={`text-xl font-semibold ${ok ? "text-emerald-800" : "text-red-700"}`} data-testid="insurance-status-label">{ok ? "Assicurazione pagata" : "Assicurazione non pagata"}</div>
          <div className="text-sm text-stone-600">{ok ? `Valida fino al ${data.expires}${data.current?.paid_at ? ` · registrata il ${itDate(data.current.paid_at)}` : ""}` : "Rivolgiti alla segreteria per completare il pagamento."}</div>
        </div>
      </Card>
      {data.history.length > 0 && (
        <Card className="p-5 border border-stone-200 rounded-xl shadow-none" data-testid="insurance-history">
          <div className="text-[11px] uppercase tracking-widest text-stone-500 mb-2">Storico</div>
          <ul className="divide-y divide-stone-100 text-sm">
            {data.history.map((r) => <li key={r.year} className="py-2 flex justify-between"><span>Anno {r.year}</span><span className="text-emerald-700">Pagata{r.paid_at ? ` il ${itDate(r.paid_at)}` : ""}</span></li>)}
          </ul>
        </Card>
      )}
    </div>
  );
}
